import angular from "angular";
import { configureStates, resolveFromParam, RouteDeclaration } from "../../core/router/router-helper.provider";

const routes: RouteDeclaration[] = [{
    // Legacy route
    state: "payrollInvoice",
    config: {
        name: "payrollInvoice",
        url: "/PayrollInvoice",
        redirectTo: "payrollInvoice.list"
    }
}, {
    // Legacy route
    state: "payrollInvoice.index",
    config: {
        name: "payrollInvoice.index",
        url: "/Index?{icdCorporationID:int}&{startDate:date}&{endDate:date}",
        redirectTo: "payrollInvoice.list"
    }
}, {
    state: "payrollInvoice.list",
    config: {
        name: "payrollInvoice.list",
        url: "^/payroll-invoices?{icdCorporationID:int}&{startDate:date}&{endDate:date}",
        component: "apexPayrollInvoiceList",
        params: {
            // The page implements data loading logic, so mark params as dynamic to avoid reloading the component.
            icdCorporationID: { dynamic: true },
            startDate: { dynamic: true },
            endDate: { dynamic: true }
        },
        resolve: {
            icdCorporationID: resolveFromParam("icdCorporationID"),
            startDate: resolveFromParam("startDate"),
            endDate: resolveFromParam("endDate")
        },
        data: {
            pageHeader: "Payroll Invoices"
        }
    }
}, {
    state: "payrollInvoice.new",
    config: {
        name: "payrollInvoice.new",
        url: "/new",
        component: "apexPayrollInvoiceGeneratorContainer",
        data: {
            pageHeader: "Unbilled License Fees - Generate Invoices"
        }
    }
}];

export const PayrollInvoicingRoutingModule = angular
    .module("apex.mainApp.payrollInvoicing.routing", [])
    .run(configureStates(routes))
    .name;

